export default __webpack_public_path__ + "0c1eec934625db1f890b6584f31ffe35.png";